import type { AchievementType } from '../api/types'
import { ACHIEVEMENT_TYPE } from '../constants/api'

export function isAchievementType(value: unknown): value is AchievementType {
  return value === ACHIEVEMENT_TYPE.recognized || value === ACHIEVEMENT_TYPE.partner
}

export function normalizeAchievementType(value: unknown): AchievementType {
  return isAchievementType(value) ? value : ACHIEVEMENT_TYPE.recognized
}
